const gsmChars: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
    'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
    'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    '!', '#', ' ', '"', '%', '&', '\'', '(', ')', '*', ',', '.', '?',
    '+', '-', '/', ';', ':', '<', '=', '>', '¡', '¿', '_', '@',
    '$', '£', '¥', '¤',
    'è', 'é', 'ù', 'ì', 'ò', 'Ç', 'Ø', 'ø', 'Æ', 'æ', 'ß', 'É', 'Å',
    'å', 'Ä', 'Ö', 'Ñ', 'Ü', '§', 'ä', 'ö', 'ñ', 'ü', 'à',
    'Δ','Φ','Ξ','Γ','Ω','Π','Ψ','Σ','Θ','Λ'];


/**
 * Helpful Docs:
 * - GSM Encoding: https://www.twilio.com/docs/glossary/what-is-gsm-7-character-encoding 
 * - Emojis: https://www.twilio.com/blog/2017/03/what-the-heck-is-a-segment.html
 * - Twilio Message Segement Calculator: https://twiliodeved.github.io/message-segment-calculator/
 * - SMS Character Limit: https://www.twilio.com/docs/glossary/what-sms-character-limit
 * - Max Length of Message: https://help.twilio.com/articles/360033806753-Maximum-Message-Length-with-Twilio-Programmable-Messaging
 * @param messageBody 
 */
export const calculateTotalMessageSegmentsInMessageBody = (messageBody: string) => {
    // First - Check what type of encoding should be used
    // -- Twilio will automatically send messages in the most compact encoding possible.
    // -- If you include any non GSM-7 characters in your message body, we will automatically fall back to UCS-2 encoding (which will limit message bodies to 70 characters each).
    const canBeEncodedInGSM: boolean = checkIfMessageBodyCanBeEncodedInGSM(messageBody);

    // Next - check the total length of the message
    const charCount: number = messageBody.length;

    let messageSegmentCount: number = 0;
    if (canBeEncodedInGSM) {
        messageSegmentCount = Math.ceil(charCount/160);
    } else {
        messageSegmentCount = Math.ceil(charCount/70);
    }

    return messageSegmentCount;
}

export const calculateTotalCharsInMessageBody = (messageBody: string) => {

}

/**
 * Determing the type of encoding that needs to be used for the current message
 * Options: GSM-7 or UCS-2
 * - Goal 
 * 
 * Helpful Docs:
 * - GSM Encoding: https://www.twilio.com/docs/glossary/what-is-gsm-7-character-encoding 
 * - Emojis: https://www.twilio.com/blog/2017/03/what-the-heck-is-a-segment.html
 * @param messageBody 
 * @returns 
 */
export const checkIfMessageBodyCanBeEncodedInGSM = (messageBody: string): boolean => {
    const charArray: string[] = messageBody.split("");
    let isGSMCompliant = true;
    charArray.forEach((char: string) => {
        const foundCharIsInGSMChars = gsmChars.find((c) => c === char);
        if (!foundCharIsInGSMChars) isGSMCompliant = false;
    });
    return isGSMCompliant;
}
